<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-speedometer"></i>
        <div class="mg-l-20">
          <h4>
            {{ $t("order.商品销量报表") }}
            <span class="mg-l-15 tx-12 tx-gray-300"
              >({{ $t("order.截止日期：") }}{{ date }})</span
            >
          </h4>
        </div>
      </div>
      <div class="tx-right">
        <button
          class="btn btn-primary"
          @click="exportItems"
          v-if="isSysRights('Order.exportProductSales')"
        >
          {{ $t("order.导出报表") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="key_sku"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('sku')"
        >
          SKU：
          <span class="mg-r-10">{{ key_sku }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="batchBool"
          @click="clearKey('batchBool')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("distributor.批量搜索") }}
          
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["key_sku",'batchBool'],
  data() {
    return {
      date: moment().subtract(1, "days").utcOffset(480).format("YYYY-MM-DD"),
    };
  },
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    exportItems() {
      this.$emit("exportItems");
    },
  },
};
</script>